(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dmtportal-art-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-art-gallery')) customElements.define('dp-art-gallery', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const items = [...this.querySelectorAll('.dp-artwork')];
    const stage = this.querySelector('.dp-gallery-stage');
    if (!items.length) return;
    let index = 0, startX = null, startY = null;
    const show = (n, scroll = false) => {
      index = (n + items.length) % items.length;
      items.forEach((item, i) => item.hidden = i !== index);
      const counter = this.querySelector('.dp-gallery-count');
      counter.textContent = (index + 1) + ' / ' + items.length;
      counter.setAttribute('aria-label', this.dataset.countLabel.replace('__INDEX__', index + 1).replace('__COUNT__', items.length));
      try { sessionStorage.setItem('dp-gallery-last', String(index)); } catch {}
      if (scroll) this.querySelector('.dp-gallery-controls').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth', block:'start'});
    };
    const random = () => {
      let last = -1;
      try { last = Number(sessionStorage.getItem('dp-gallery-last')); } catch {}
      let n = Math.floor(Math.random() * items.length);
      if (n === last && items.length > 1) n = (n + 1 + Math.floor(Math.random() * (items.length - 1))) % items.length;
      show(n);
    };
    const fromLink = () => {
      let hash = '';
      try { hash = decodeURIComponent(location.hash.slice(1)); } catch {}
      const linked = items.findIndex(item => item.id === hash);
      if (linked >= 0) { show(linked); return true; }
      return false;
    };
    this.querySelectorAll('[data-prev]').forEach(b => b.addEventListener('click', () => show(index - 1, true)));
    this.querySelectorAll('[data-next]').forEach(b => b.addEventListener('click', () => show(index + 1, true)));
    this.querySelector('[data-random]').addEventListener('click', random);
    stage.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(index + (e.key === 'ArrowRight' ? 1 : -1)); }
    });
    stage.addEventListener('touchstart', e => { startX=e.touches[0].clientX; startY=e.touches[0].clientY; }, {passive:true});
    stage.addEventListener('touchend', e => {
      const end=e.changedTouches[0], dx=end.clientX-startX, dy=end.clientY-startY;
      if(startX!==null && Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.4) show(index+(dx<0?1:-1));
      startX=startY=null;
    }, {passive:true});
    this.back = e => { if (e.persisted && !fromLink()) random(); };
    this.hashChanged = () => fromLink();
    window.addEventListener('pageshow', this.back);
    window.addEventListener('hashchange', this.hashChanged);
    if (!fromLink()) random();
  }
  disconnectedCallback() {
    window.removeEventListener('pageshow', this.back);
    window.removeEventListener('hashchange', this.hashChanged);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmtportal-collab-doorway"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-collab-stills')) customElements.define('dp-collab-stills', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.cards = [...this.querySelector('template').content.querySelectorAll('a')];
    this.refresh();
    this.onReturn = event => { if (event.persisted) this.refresh(); };
    window.addEventListener('pageshow', this.onReturn);
  }
  refresh() {
    if (this.cards.length < 3) return;
    const key = 'dp-collab-stills-' + this.dataset.key;
    let previous = this.previous || '';
    try { previous = sessionStorage.getItem(key) || previous; } catch {}
    const pool = [...this.cards];
    for (let i=pool.length-1; i>0; i--) { const j=Math.floor(Math.random()*(i+1)); [pool[i],pool[j]]=[pool[j],pool[i]]; }
    const signature = cards => cards.map(card=>card.dataset.key).sort().join('|');
    if (pool.length>3 && signature(pool.slice(0,3))===previous) [pool[2],pool[3]]=[pool[3],pool[2]];
    const selected=pool.slice(0,3);
    this.querySelector('.dp-collab-still-grid').replaceChildren(...selected.map(card=>card.cloneNode(true)));
    this.previous=signature(selected);
    try { sessionStorage.setItem(key,this.previous); } catch {}
  }
  disconnectedCallback() { window.removeEventListener('pageshow',this.onReturn); this.initialized=false; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmtportal-collabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-collab-player')) customElements.define('dp-collab-player', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', () => this.start());
  }
  start() {
    if (!this.video) {
      this.append(this.querySelector('template').content.cloneNode(true));
      this.video = this.querySelector('video');
      this.video.tabIndex = 0;
      this.video.setAttribute('aria-label', this.button.getAttribute('aria-label'));
      this.video.poster = this.querySelector('.dp-collab-poster')?.currentSrc || '';
      this.video.addEventListener('play', () => {
        document.querySelectorAll('dp-collab-player video').forEach(other => { if (other !== this.video) other.pause(); });
        this.querySelector('.dp-collab-error').hidden = true;
        this.button.hidden = true;
      });
      this.video.addEventListener('error', () => { this.querySelector('.dp-collab-error').hidden = false; this.button.hidden = false; });
      this.video.addEventListener('ended', () => { this.video.hidden = true; this.button.hidden = false; this.video.currentTime = 0; });
    }
    this.video.hidden = false;
    this.video.play().then(() => { this.button.hidden = true; this.video.focus(); }).catch(() => { this.button.hidden = false; });
  }
  disconnectedCallback() { this.video?.pause(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmtportal-discography"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dp-discography'))customElements.define('dp-discography',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const input=this.querySelector('input'),rows=[...this.querySelectorAll('.dp-single')];input.addEventListener('input',()=>{let count=0;const q=input.value.trim().toLowerCase();rows.forEach(r=>{r.hidden=!r.dataset.title.includes(q);if(!r.hidden)count++});this.querySelector('[data-results]').textContent=count+' / '+rows.length;this.querySelector('[data-empty]').hidden=count>0})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmtportal-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dp-media'))customElements.define('dp-media',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.start=()=>{const source=this.querySelector('template');if(!source)return;document.dispatchEvent(new CustomEvent('dp:media',{detail:this}));this.stop();this.append(source.content.cloneNode(true));const frame=this.querySelector('iframe');if(frame)frame.src=frame.dataset.src;const video=this.querySelector('video');if(video)video.play().catch(()=>{});this.dataset.active='true';};this.stop=()=>{this.querySelectorAll(':scope>iframe,:scope>video').forEach(x=>{if(x.tagName==='VIDEO')x.pause();x.remove()});this.dataset.active='false';};this.other=e=>{if(e.detail!==this)this.stop()};this.querySelector('.dp-play')?.addEventListener('click',this.start);document.addEventListener('dp:media',this.other);}
disconnectedCallback(){document.removeEventListener('dp:media',this.other);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmtportal-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-hero')) customElements.define('dp-hero', class extends HTMLElement {
 connectedCallback() {
  const templates = Array.from(this.querySelectorAll('template[data-loop-id]'));
  const button = this.querySelector('.dp-motion'), poster = this.querySelector('.dp-hero-poster');
  if (!templates.length || this.abort) return;
  this.abort = new AbortController();
  const options = { signal: this.abort.signal }, reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let video, chosen, intended = !reduced.matches && !navigator.connection?.saveData, visible = true;
  const label = () => { button.textContent = video && !video.paused ? button.dataset.pause : button.dataset.play; };
  const select = () => {
   let last = chosen?.dataset.loopId;
   try { last = localStorage.getItem('dmtportal-entrance-last-v1') || last; } catch {}
   const candidates = templates.filter(t => t.dataset.loopId !== last);
   const pool = candidates.length ? candidates : templates;
   chosen = window.Shopify?.designMode ? templates[0] : pool[Math.floor(Math.random() * pool.length)];
   if (!window.Shopify?.designMode) try { localStorage.setItem('dmtportal-entrance-last-v1', chosen.dataset.loopId); } catch {}
   if (video) { video.pause(); video.remove(); video = null; }
   if (poster && chosen.dataset.poster) {
    poster.removeAttribute('srcset'); poster.src = chosen.dataset.poster; poster.alt = chosen.dataset.alt || '';
   }
  };
  const ensure = () => {
   if (video) return video;
   chosen.after(chosen.content.cloneNode(true)); video = this.querySelector('video');
   video.muted = true; video.playsInline = true;
   video.addEventListener('play', label, options);
   video.addEventListener('pause', label, options);
   video.addEventListener('error', () => { video.hidden = true; intended = false; label(); }, options);
   return video;
  };
  const sync = () => {
   if (intended && visible && !document.hidden) ensure().play().catch(label);
   else if (video) video.pause();
   label();
  };
  select(); button.hidden = false;
  button.addEventListener('click', () => {
   intended = !video || video.paused;
   if (intended) ensure().hidden = false;
   sync();
  }, options);
  reduced.addEventListener('change', () => { if (reduced.matches) { intended = false; sync(); } }, options);
  document.addEventListener('visibilitychange', sync, options);
  window.addEventListener('pageshow', event => {
   if (event.persisted) { select(); intended = !reduced.matches && !navigator.connection?.saveData; sync(); }
  }, options);
  this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
  this.observer.observe(this); sync();
 }
 disconnectedCallback() {
  this.observer?.disconnect(); this.abort?.abort(); this.abort = null;
  this.querySelector('video')?.pause(); this.querySelector('video')?.remove();
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmtportal-music"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dp-music-player'))customElements.define('dp-music-player',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const target=this.querySelector('.dp-music-frame');this.other=e=>{if(e.detail!==this)target.replaceChildren()};document.addEventListener('dp:media',this.other);this.querySelectorAll('[data-service]').forEach(b=>b.addEventListener('click',()=>{let u;try{u=new URL(b.dataset.url)}catch{return}let src;if(b.dataset.service==='spotify'&&u.hostname==='open.spotify.com'&&u.pathname.startsWith('/album/'))src='https://open.spotify.com/embed'+u.pathname+'?theme=0';if(b.dataset.service==='apple'&&u.hostname==='music.apple.com'){u.hostname='embed.music.apple.com';src=u.toString()}if(!src)return;document.dispatchEvent(new CustomEvent('dp:media',{detail:this}));const f=document.createElement('iframe');f.src=src;f.title=this.dataset.title+' — '+b.dataset.service;f.allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';target.replaceChildren(f)}))}disconnectedCallback(){document.removeEventListener('dp:media',this.other)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmtportal-portals"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('dp-random-artworks')) customElements.define('dp-random-artworks', class extends HTMLElement {
  async connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.onReturn = event => { if (event.persisted) this.refresh(); };
    window.addEventListener('pageshow', this.onReturn);
    await this.refresh();
  }
  disconnectedCallback() {
    window.removeEventListener('pageshow', this.onReturn);
    this.initialized = false;
  }
  async refresh() {
    if (this.busy) return;
    this.busy = true;
    try {
      if (!this.artworks) {
        const url = new URL(this.dataset.galleryUrl, location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Gallery unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const seen = new Set();
        this.artworks = [...doc.querySelectorAll('.dp-artwork')].flatMap(art => {
          const img = art.querySelector('.dp-artwork-image img');
          const key = art.dataset.galleryKey;
          if (!img || !key || seen.has(key)) return [];
          seen.add(key);
          return [{ key, src: img.getAttribute('src'), alt: img.alt, width: img.width || 1080, height: img.height || 1350 }];
        });
      }
      if (this.artworks.length < 3) return;
      let previous = this.previous || [];
      try { previous = JSON.parse(sessionStorage.getItem('dp-home-artworks') || '[]'); } catch {}
      if (!Array.isArray(previous)) previous = [];
      let pool = this.artworks.filter(art => !previous.includes(art.key));
      if (pool.length < 3) pool = [...this.artworks];
      for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      const selected = pool.slice(0, 3);
      const cards = await Promise.all(selected.map(async art => {
        const card = document.createElement('div');
        const img = new Image();
        const url = new URL(art.src, location.origin);
        if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', '900');
        img.alt = art.alt;
        img.width = art.width;
        img.height = art.height;
        img.decoding = 'async';
        img.src = url.href;
        await img.decode();
        card.append(img);
        return card;
      }));
      if (!this.isConnected) return;
      this.replaceChildren(...cards);
      this.previous = selected.map(art => art.key);
      try { sessionStorage.setItem('dp-home-artworks', JSON.stringify(this.previous)); } catch {}
    } catch {
    } finally {
      this.busy = false;
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmtportal-store"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-dp-random-tees]';
  const shuffle = (items) => {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };
  const refresh = (section) => {
    const grid = section.querySelector('.dp-tee-grid');
    const pool = section.querySelector('[data-tee-pool]');
    if (!grid || !pool) return;
    const cards = Array.from(pool.content.children);
    if (!cards.length) return;
    const count = Math.min(Number(section.dataset.teeCount) || 6, cards.length);
    const key = 'dmtportal:featured-tees:' + section.dataset.teeCollection;
    let previous = [];
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '[]');
      if (Array.isArray(saved)) previous = saved;
    } catch (error) {}
    if (!previous.length) {
      previous = Array.from(grid.children, (card) => card.dataset.teeId);
    }
    const seen = new Set(previous);
    const fresh = shuffle(cards.filter((card) => !seen.has(card.dataset.teeId)));
    const returning = shuffle(cards.filter((card) => seen.has(card.dataset.teeId)));
    const chosen = fresh.concat(returning).slice(0, count);
    grid.replaceChildren(...chosen.map((card) => card.cloneNode(true)));
    try {
      localStorage.setItem(key, JSON.stringify(chosen.map((card) => card.dataset.teeId)));
    } catch (error) {}
  };
  const refreshAll = (root = document) => root.querySelectorAll(selector).forEach(refresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refreshAll(), { once: true });
  } else {
    refreshAll();
  }
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshAll();
  });
  document.addEventListener('shopify:section:load', (event) => refreshAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmtportal-visuals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-cinema')) customElements.define('dp-cinema', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const tabs = [...this.querySelectorAll('[role=tab]')];
    const panels = [...this.querySelectorAll('.dp-film-panel')];
    const picks = [...this.querySelectorAll('.dp-film-pick')];
    const layout = this.querySelector('.dp-cinema-layout');
    const selected = new Map();
    const portraitPicks = picks.filter(x => x.dataset.ratio === '9/16');
    let allowed = new Set(portraitPicks.map(x => x.dataset.film));
    const randomize = () => {
      if (window.Shopify?.designMode || portraitPicks.length <= 10) return;
      const shuffled = portraitPicks.slice();
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      const key = 'dmtportal-portrait-selection-v1';
      let previous = [];
      try { previous = JSON.parse(sessionStorage.getItem(key) || '[]'); } catch (_) {}
      if (!Array.isArray(previous)) previous = [];
      let chosen = shuffled.slice(0, 10);
      if (chosen.every(x => previous.includes(x.dataset.film))) {
        const replacement = shuffled.slice(10).find(x => !previous.includes(x.dataset.film));
        if (replacement) chosen[9] = replacement;
      }
      if (chosen[0].dataset.film === previous[0]) [chosen[0], chosen[1]] = [chosen[1], chosen[0]];
      allowed = new Set(chosen.map(x => x.dataset.film));
      const rail = this.querySelector('.dp-film-rail');
      chosen.forEach((pick, i) => {
        pick.querySelector('.dp-film-number').textContent = String(i + 1).padStart(2, '0');
        rail.append(pick);
      });
      picks.filter(x => x.dataset.ratio !== '9/16').forEach(x => rail.append(x));
      selected.delete('9/16');
      selected.set('9/16', chosen[0].dataset.film);
      try { sessionStorage.setItem(key, JSON.stringify(chosen.map(x => x.dataset.film))); } catch (_) {}
    };
    randomize();
    const choose = id => {
      const panel = panels.find(x => x.dataset.film === id);
      if (!panel) return;
      document.dispatchEvent(new CustomEvent('dp:media'));
      selected.set(panel.dataset.ratio, id);
      panels.forEach(x => x.hidden = x !== panel);
      picks.forEach(x => x.setAttribute('aria-pressed', String(x.dataset.film === id)));
    };
    const format = ratio => {
      this.dataset.ratio = ratio;
      tabs.forEach(tab => {
        const active = tab.dataset.ratio === ratio;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active) layout.setAttribute('aria-labelledby', tab.id);
      });
      picks.forEach(x => x.hidden = x.dataset.ratio !== ratio || (x.dataset.ratio === '9/16' && !allowed.has(x.dataset.film)));
      choose(selected.get(ratio) || picks.find(x => x.dataset.ratio === ratio)?.dataset.film);
    };
    picks.forEach(button => button.addEventListener('click', () => choose(button.dataset.film)));
    tabs.forEach((button, i) => {
      button.addEventListener('click', () => format(button.dataset.ratio));
      button.addEventListener('keydown', event => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = tabs[event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + 1) % tabs.length];
        next.click();
        next.focus();
      });
    });
    this.onBlockSelect = event => {
      const panel = panels.find(x => x.dataset.film === event.detail?.blockId);
      if (!panel) return;
      format(panel.dataset.ratio);
      choose(panel.dataset.film);
    };
    this.addEventListener('shopify:block:select', this.onBlockSelect);
    format(this.dataset.ratio);
    this.onPageShow = event => { if (event.persisted) { randomize(); format(this.dataset.ratio); } };
    window.addEventListener('pageshow', this.onPageShow);
  }
  disconnectedCallback() {
    this.removeEventListener('shopify:block:select', this.onBlockSelect);
    window.removeEventListener('pageshow', this.onPageShow);
    this.ready = false;
  }
});

  } catch(e) { console.error(e); }
})();
})();
